export default __webpack_public_path__ + "static/media/649.a564daf5.png";